import { createTheme, MantineThemeOverride } from "@mantine/core";

export const primaryColor = "teal";

export const mantineTheme: MantineThemeOverride = createTheme({
  primaryColor,
  fontFamily: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  headings: {
    fontFamily:
      "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  },
  defaultRadius: "md",
});
